import {Injectable} from '@angular/core';

/**
 * Translations for product settings.
 */
@Injectable()
export class ProductSettingsTranslationService {

  public campaign: any = $localize`:@@general.text.campaign:Campaign`;

  public merchandising: any = $localize`:@@general.text.merchandising:Merchandising`;

  public tixxSelect: any = $localize`:@@general.text.tixxSelect:Tixx-Select`;

  public membership: any = $localize`:@@general.text.membership:Membership`;

  public campaiMembership: any = $localize`:@@general.text.campaiMembership:Campai Membership`;

  public tixxWebshop: any = $localize`:@@general.text.tixxWebshop:Tixx Organiser`;

  public customer: any = $localize`:@@general.text.customer:Customer`;

  public invoice: any = $localize`:@@general.text.invoice:Invoice`;

  public eventimDataFeed: any = $localize`:@@general.text.eventimDataFeed:Eventim data feed`;

  public fanScoreCard: any = $localize`:@@general.text.fanScoreCard:Fan Score Card`;

  public fanPortal: any = $localize`:@@general.text.fanPortal:Tixx-FanPortal`;

  constructor() { }
}
